/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  Checkbox,
  Typography,
  useMediaQuery,
  useTheme,
  Skeleton,
  TextField,
} from "@mui/material";

import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  useLazyGetPaymentDetailsQuery,
  useLazyGetPaymentMethodByIdQuery,
  usePostPaymentDetailsMutation,
  usePostPaymentMethodMutation,
  usePutPaymentDetailsMutation,
} from "@api/applications";
import { RootState } from "@store/store";
import { useLazyGetPaymentMethodQuery } from "@api/catalogs";
import CustomRadioGroup from "@components/CustomRadioGroup";
import { InactivityHandler } from "@components/InactivityHandler";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { ApiError } from "@interfaces/response";
import CustomRightImage from "@components/CustomRightImagev2";
import * as Sentry from "@sentry/react";

const InformacionTransaccional = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const applicationData = useSelector((state: RootState) => state.register.application);

  const [triggerPaymentMethod] = usePostPaymentMethodMutation();
  const [triggerPaymentDetails] = usePostPaymentDetailsMutation();
  const [triggerPutPaymentDetails] = usePutPaymentDetailsMutation();
  const [getPaymentMethod] = useLazyGetPaymentMethodQuery();
  const [getDetalles] = useLazyGetPaymentDetailsQuery();
  const [getMetodoByApplication] = useLazyGetPaymentMethodByIdQuery();

  const [idOtherPayment, setIdOtherPayment] = useState("");
  const [idDetalle, setIdDetalle] = useState<string | null>(null);
  const [paymentMethodList, setPaymentMethodList] = useState<Array<{ id: string; description: string }>>([]);

  const formik = useFormik({
    initialValues: {
      paymentMethods: [] as string[],
      otherPaymentMethod: "",
      advancePayments: "",
      resourcesTypes: "",
      otro: false,
    },
    validationSchema: yup.object().shape({
      paymentMethods: yup.array().min(1).of(yup.string().required()).required(),
      otro: yup.boolean(),
      otherPaymentMethod: yup.string().when("otro", {
        is: true,
        then: (schema) => schema.required("Este campo es requerido cuando la opción otro esta seleccionada"),
        otherwise: (schema) => schema.notRequired(),
      }),
      advancePayments: yup.string().required("Campo requerido"),
      resourcesTypes: yup.string().required("Campo requerido"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);

        await triggerPaymentMethod({
          solicitudId: applicationData.id,
          body: {
            payment_methods: values.paymentMethods.map((id) => ({
              payment_method_id: id,
              other_payment_method: id === idOtherPayment ? values.otherPaymentMethod : null,
            })),
          },
        }).unwrap();

        const body = {
          advance_payments: values.advancePayments === "Si",
          own_account: false,
          own_resources: values.resourcesTypes === "Propios",
        };

        if (idDetalle) {
          await triggerPutPaymentDetails({
            solicitudId: applicationData.id,
            detailId: idDetalle,
            body,
          }).unwrap();
        } else {
          await triggerPaymentDetails({
            solicitudId: applicationData.id,
            body,
          }).unwrap();
        }

        navigate("/producto/creditosimple/solicitud_credito_3");
      } catch (error) {
        const api_error = error as ApiError;
        Sentry.captureException(error, {
          extra: {
            component: "SolicitudCreditoPart2-submit",
          },
        });
        dispatch(setModalErrorVisible({ open: true, error: api_error }));
      } finally {
        setSubmitting(false);
      }
    },
  });

  // const savePaymentMethods = async (
  //   e:
  //     | React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  //     | React.FocusEvent<HTMLInputElement, Element>
  //     | React.SyntheticEvent<Element, Event>,
  // ) => {
  //   try {
  //     formik.handleBlur(e);

  //     const { values, errors } = formik;

  //     const { paymentMethods, otherPaymentMethod, advancePayments, resourcesTypes } = errors;
  //     if (paymentMethods || otherPaymentMethod || advancePayments || resourcesTypes) {
  //       return;
  //     }

  //     const payload = {
  //       payment_methods: values.paymentMethods.map((id) => ({
  //         payment_method_id: id,
  //         other_payment_method: id === idOtherPayment ? values.otherPaymentMethod : null,
  //       })),
  //     };

  //     await triggerPaymentMethod({
  //       solicitudId: applicationData.id,
  //       body: payload,
  //     }).unwrap();
  //   } catch (error) {
  //     console.error("Error guardando información de pago:", error);
  //   }
  // };

  // const saveDetails = async (
  //   e:
  //     | React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  //     | React.FocusEvent<HTMLInputElement, Element>
  //     | React.SyntheticEvent<Element, Event>,
  // ) => {
  //   try {
  //     formik.handleBlur(e);

  //     const { values, errors } = formik;

  //     const { advancePayments, resourcesTypes } = errors;
  //     if (advancePayments || resourcesTypes) {
  //       return;
  //     }

  //     const payload = {
  //       advance_payments: values.advancePayments === "Si",
  //       own_account: false,
  //       own_resources: values.resourcesTypes === "Propios",
  //     };

  //     if (idDetalle) {
  //       await triggerPutPaymentDetails({
  //         solicitudId: applicationData.id,
  //         detailId: idDetalle,
  //         body: payload,
  //       }).unwrap();
  //     } else {
  //       const newDetail = await triggerPaymentDetails({
  //         solicitudId: applicationData.id,
  //         body: payload,
  //       }).unwrap();
  //       setIdDetalle(newDetail.data.id);
  //     }
  //   } catch (error) {
  //     console.error("Error guardando información de pago:", error);
  //   }
  // };

  const getDetallesWrapped = async () => {
    try {
      return await getDetalles({ solicitudId: applicationData.id }).unwrap();
    } catch (error) {
      return null;
    }
  };

  const fetchInitialData = async () => {
    try {
      const [detallesResponse, metodoResponse, paymentCatalog] = await Promise.all([
        getDetallesWrapped(),
        getMetodoByApplication({ solicitudId: applicationData.id }).unwrap(),
        getPaymentMethod().unwrap(),
      ]);

      const detallesData = detallesResponse?.data;
      const metodoData = metodoResponse.data;

      // buscar el id del metodo de pago "OTRO"
      const otherPaymentMethod = paymentCatalog.find((item) => item.code === "CPIOT");
      const paymentMethodIds = metodoData?.map((item) => item.payment_method?.id) ?? [];
      const paymentMethodInput = metodoData?.find((item) => item.payment_method?.id === otherPaymentMethod?.id);

      formik.setFieldValue("resourcesTypes", detallesData ? (detallesData.own_resources ? "Propios" : "Tercero") : "");
      formik.setFieldValue("advancePayments", detallesData ? (detallesData.advance_payments ? "Si" : "No") : "");
      formik.setFieldValue("paymentMethods", paymentMethodIds);
      formik.setFieldValue("otherPaymentMethod", paymentMethodInput?.other_payment_method || "");

      setIdDetalle(detallesData?.id ?? null);
      setIdOtherPayment(otherPaymentMethod?.id ?? "");
      setPaymentMethodList(paymentCatalog);
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          component: "SolicitudCreditoPart2-fetchInitialData",
        },
      });
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    const isOtherSelected = formik.values.paymentMethods.includes(idOtherPayment);
    formik.setFieldValue("otro", isOtherSelected);
  }, [formik.values.paymentMethods, idOtherPayment]);

  const handleOnClickRestart = () => {
    navigate("/producto/creditosimple/avance_expediente_digital");
  };

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={4}>
        <InactivityHandler />
        <Box maxWidth="sm" mx="auto" mt={4} px={2}>
          <Typography
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            fontWeight={700}
            color={theme?.palette?.primary?.dark}
          >
            Solicitud de crédito
          </Typography>

          <Typography
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
            mt={2}
          >
            <strong>2</strong> de 3
          </Typography>

          <Typography
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
            fontWeight={600}
            mt={3}
          >
            Información transaccional
          </Typography>

          <form onSubmit={formik.handleSubmit} noValidate>
            <Box textAlign={"left"} my={2}>
              <Typography variant="body1" color={theme?.palette?.primary?.dark}>
                ¿De qué forma realizarás tus pagos?
              </Typography>
              <FormGroup>
                {paymentMethodList.length > 0 ? (
                  paymentMethodList.map((paymentMethod, index) => (
                    <FormControlLabel
                      key={index}
                      color={theme?.palette?.primary?.dark}
                      control={
                        <Checkbox
                          key={paymentMethod.id}
                          name="paymentMethods"
                          checked={formik.values.paymentMethods.includes(
                            paymentMethod.id as `${string}-${string}-${string}-${string}-${string}`,
                          )}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={paymentMethod.id}
                        />
                      }
                      label={paymentMethod.description}
                    />
                  ))
                ) : (
                  <>
                    <Skeleton variant="text" width={300} height={40}></Skeleton>
                    <Skeleton variant="text" width={300} height={40}></Skeleton>
                    <Skeleton variant="text" width={300} height={40}></Skeleton>
                    <Skeleton variant="text" width={300} height={40}></Skeleton>
                  </>
                )}
              </FormGroup>
              {formik.values.otro && (
                <TextField
                  fullWidth
                  id="otherPaymentMethod"
                  name="otherPaymentMethod"
                  label="Especifica el método de pago"
                  value={formik.values.otherPaymentMethod}
                  required
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.otherPaymentMethod && Boolean(formik.errors.otherPaymentMethod)}
                  helperText={formik.touched.otherPaymentMethod && formik.errors.otherPaymentMethod}
                  margin="normal"
                />
              )}
            </Box>
            <Box textAlign={"left"} my={2}>
              <CustomRadioGroup
                label={"¿Realizarás pagos anticipados?"}
                name={"advancePayments"}
                value={formik.values.advancePayments}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.advancePayments && Boolean(formik.errors.advancePayments)}
                helperText={formik.touched.advancePayments && formik.errors.advancePayments}
                options={[
                  {
                    label: "Si",
                    value: "Si",
                  },
                  {
                    label: "No",
                    value: "No",
                  },
                ]}
              />
            </Box>
            <Box textAlign={"left"} my={2}>
              <CustomRadioGroup
                label={"¿Los recursos son propios o de un tercero?"}
                name={"resourcesTypes"}
                value={formik.values.resourcesTypes}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.resourcesTypes && Boolean(formik.errors.resourcesTypes)}
                helperText={formik.touched.resourcesTypes && formik.errors.resourcesTypes}
                options={[
                  {
                    label: "Propios",
                    value: "Propios",
                  },
                  {
                    label: "De un tercero",
                    value: "Tercero",
                  },
                ]}
              />
            </Box>

            <Grid container columnSpacing={1} my={4}>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="blue_outlined"
                  sx={{ padding: "0", height: "100%" }}
                  onClick={handleOnClickRestart}
                  disabled={formik.isSubmitting}
                >
                  Regresar al inicio
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="default"
                  disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
                >
                  Continuar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default InformacionTransaccional;
